import { Component, Input } from "@angular/core";

import { PageObjectText } from "src/app/models/pageobjecttext";

@Component({
  selector: "hkt-pageobjecttext",
  templateUrl: "./pageobjecttext.component.html",
  styleUrls: ["./pageobjecttext.component.scss"],
})
export class PageObjectTextComponent {
  @Input("obj") obj: PageObjectText;
  @Input("mode") mode: string;

  constructor() {}
}
